module.exports = __webpack_public_path__ + "static/media/Circo2025_23.0e551d87.webp";